import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { SegmentTypes } from '../../../../../../models/itinerary';
import { AppState } from '../../../../../../store/model';
import { getSegmentType, isSaviSelectIntl } from '../../../../../../store/reducers/itinerary/selectors';
import { AirRoute } from './AirRoute';
import { CarRoute } from './CarRoute';
import { HotelRoute } from './HotelRoute';
import { getSegmentTypeForSaviSelectIntl } from '../../../../../../store/reducers/itinerary/saviSelectIntlSelector';

interface OwnProps {
  optionId: string;
  segmentId: number;
}

interface StateProps {
  type: SegmentTypes;
}

interface RouteTypeProps extends OwnProps, StateProps {}

class RouteTypeBase extends PureComponent<RouteTypeProps> {

  public render() {
    const { optionId, segmentId } = this.props;

    const Route = this.getRouteComponent();

    return <Route optionId={optionId} segmentId={segmentId} />;
  }
  private getRouteComponent = () => {
    switch (this.props.type) {
      case 'Air':
        return AirRoute;
      case 'Car':
        return CarRoute;
      case 'Hotel':
        return HotelRoute;
    }
  };
}

const mapStateToProps = (state: AppState, { segmentId }: OwnProps) => {
  return {
    type: !isSaviSelectIntl(state) ? getSegmentType(segmentId)(state) : getSegmentTypeForSaviSelectIntl(segmentId)(state),
  };
};

const enhance = compose<RouteTypeProps, OwnProps>(connect(mapStateToProps));

export const RouteType = enhance(RouteTypeBase);

RouteType.displayName = 'RouteType';
